import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';
import { formatTime } from '../../lib/arcade/formatTime';

/** Top-10 table + "your best" line for one arcade game (C). */
@observer
class ArcadeLeaderboard extends Component {
    render() {
        const { game, timed = false, result } = this.props;
        const { arcadeScoreStore } = this.props.stores;
        const loadedFor = result ? game : arcadeScoreStore?.leaderboardGame;
        const leaderboard = result ? (result.data || [])
            : loadedFor === game ? (arcadeScoreStore?.leaderboard || []) : [];
        const me = result ? result.me : loadedFor === game ? (arcadeScoreStore?.me || null) : null;
        const hasBest = me && (timed ? me.durationMs > 0 : me.score > 0);
        return (
            <div class='arcade-leaderboard w-100 mt-3'>
                <div class='arcade-hud small mb-1'>
                    {timed ? <Text id='arcade.fastestTimes'>Fastest times</Text>
                        : <Text id='arcade.leaderboard'>Top 10</Text>}
                </div>
                {leaderboard.length === 0 ? (
                    <div class='text-body-secondary small'><Text id='arcade.noScores'>No scores yet — be the first!</Text></div>
                ) : (
                    <table class='table table-sm table-dark mb-1'>
                        <tbody>
                            {leaderboard.map(row => (
                                <tr key={`arcade-row-${game}-${row.user}`} class={row.isMe ? 'table-active' : ''}>
                                    <td class='text-end'>{row.rank}.</td>
                                    <td>{row.name}</td>
                                    <td class='text-end'>{timed ? formatTime(row.durationMs) : row.score}</td>
                                    {!timed && <td class='text-end text-body-secondary'>L{row.wave}</td>}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                {hasBest && (
                    <div class='small text-body-secondary'>
                        {timed ? (
                            <Text id='arcade.yourTimeRank' fields={{ time: formatTime(me.durationMs), rank: me.rank }}>
                                Your best: {formatTime(me.durationMs)} (rank {me.rank})
                            </Text>
                        ) : (
                            <Text id='arcade.yourRank' fields={{ score: me.score, rank: me.rank }}>
                                Your best: {me.score} (rank {me.rank})
                            </Text>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default ArcadeLeaderboard;
